module.exports = __webpack_public_path__ + "img/question.54ebe292.svg";